import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private selectedItemSubject = new BehaviorSubject<string>('');

  selectedItem$ = this.selectedItemSubject.asObservable();

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.updateSelectedItem(event.url);
      });
  }

  public updateSelectedItem(url: string): void {
    switch (url) {
      case '/dashboard':
        this.selectedItemSubject.next('Dashboard');
        break;
      case '/case-management':
        this.selectedItemSubject.next('Case Management');
        break;
      case '/working-groups':
        this.selectedItemSubject.next('Working Groups');
        break;
      case '/community-content':
        this.selectedItemSubject.next('Community Content');
        break;
      case '/notifications':
        this.selectedItemSubject.next('Notifications');
        break;
      case '/chat':
        this.selectedItemSubject.next('Chat');
        break;
      case '/case-management/case-categories':
        this.selectedItemSubject.next('');
        break;
      case '/users':
        this.selectedItemSubject.next('Users');
        break;
      case '/fiu-management':
        this.selectedItemSubject.next('FIU Management');
        break;
      case '/support':
        this.selectedItemSubject.next('Support');
        break;
      default:
        this.selectedItemSubject.next('');
        break;
    }
  }
}
